<template>
  <div class="header-view">
      <div class="content-view">
        <div v-if="!hasLogin" class="before-login" @click="goLogin()">
          {{ $t('headerLogin.login') }}
        </div>
        <div v-if="hasLogin" class="after-login" @click="goPerson()">
          <span class="user-icon">
            <svg aria-hidden="true" class="icon-svg">
              <use xlink:href="#icon-user"></use>
            </svg>
          </span>
          <span class="username">{{ userData.nameCn }} </span><span class="card-id"> { </span><span>{{ userData.cardId }}</span><span> } </span><span class="user-position"> {{ userData.position }}</span>
        </div>
        <div v-if="hasLogin" class="logout" @click="logOut()">
          {{ $t('headerLogin.logout') }}
        </div>
      </div>
  </div>
</template>

<script>
import { clearLoginInfo } from '@/utils'

export default {
  components: {
  },
  data () {
    return {
      hasLogin: false,
      userData: {}
    }
  },
  watch: {
  },
  created () {
    if (this.getStorage(this.GLOBAL.TOKEN)) {
      this.hasLogin = true
    }
    if (this.getStorage(this.GLOBAL.USER_DATA)) {
      this.userData = this.getStorage(this.GLOBAL.USER_DATA)
    }
    // 广播接收head-login画面
    this.$eventHub.$on(this.GLOBAL.USER_DATA, (data) => {
      this.userData = data
      this.hasLogin = true
    })
  },
  mounted() {
    sessionStorage.removeItem('AdminLoginStatus' )
  },
  methods: {
    goLogin () {
      this.$router.replace({ name: 'protalMain' })
    },
    logOut () {
      let _this = this
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('logout') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel')
      }).then(() => {
        _this.$request.post('/auth/logoutIam', {userId: this.userData.userId} ).then((res) => { ///sys/logout').then((res) => {
          clearLoginInfo()
          this.hasLogin = false
          this.setStorage('logout_state', 1)
          this.$router.push({ name: 'protalMain' })
        }).catch((err) => {
          console.error(err)
        })
      }).catch((err) => {
        console.error(err)
      })
    },
    goPerson () {
      this.$router.push({ name: 'person' })
    }
  }
}
</script>
<style lang="scss" scoped>
    .header-view{
        height: 38px;
        background: #000;
        color: #ffffff;
        display: flex;
        align-items: center;
        .content-view{
          width: 1200px;
          margin: 0 auto;
          .before-login{
            cursor: pointer;
            display: inline-block;
          }
          .after-login{
            cursor: pointer;
            display: inline-block;
            .user-icon{
              border: 1px solid #fff;
              border-radius: 10px;
            }
            svg{
              font-size: 16px;
              vertical-align: sub;
            }
            .username{
              margin-left: 6px
            }
            .card-id{
              margin-left: 6px
            }
            .user-position{
              margin-left: 6px
            }
          }
          .logout{
            cursor: pointer;
            float: right;
          }
        }
    }
</style>
